import React, { useId } from 'react';
import type { JSX } from 'react';

import Drawer from 'common/components/Drawer';
import { useBackNavigation } from 'common/hooks/back-navigation';
import { useKeyboardClose } from 'common/hooks/keyboard';
import { Element } from 'common/types/tracking';
import Container from '../../../../common-drawer/components/Container';
import Content from '../../../../common-drawer/components/Content';
import Header from '../../../../common-drawer/components/Header';

interface DrawerProps {
  title: string;
  isOpen: boolean;
  content: JSX.Element;
  onClose: (reason: Element) => void;
}

const ContactFormDrawer = ({ title, isOpen, content, onClose }: DrawerProps) => {
  const ariaLabelId = useId();

  const { onManualClose } = useBackNavigation({
    isOpen,
    onClose: () => onClose(Element.BrowserBack),
  });

  const onCloseHandler = (reason: Element) => {
    onClose(reason);
    onManualClose();
  };

  useKeyboardClose(isOpen, () => onCloseHandler(Element.Escape));

  return (
    <Drawer
      isOpen={isOpen}
      ariaLabelledby={ariaLabelId}
      onBackdropClick={() => onCloseHandler(Element.DrawerBackdrop)}
    >
      <Container>
        <Header id={ariaLabelId} onClick={() => onCloseHandler(Element.Button)} title={title} />
        <Content content={content} />
      </Container>
    </Drawer>
  );
};

export default ContactFormDrawer;
